if (!customElements.get('quantity-pack')) {
    customElements.define(
      'quantity-pack',
      class QuantityPack extends HTMLElement {
        constructor() {
          super();

          this.packs = this.querySelectorAll('.quantity-pack__pack');
          this.firstPack = this.packs[0];
          this.quantityInput = document.querySelector('.product-form__quantity .quantity__input');
        }

        quantityUpdateUnsubscriber = undefined;

        connectedCallback() {
          this.firstPack.classList.add('quantity-pack__pack--selected');
          this.quantityInput.value = this.firstPack.dataset.quantity;

          this.packs.forEach((pack) => {
            pack.addEventListener('click', this.onPackClick.bind(this));
          });

          this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onQuantityChanged.bind(this));
        }

        get selectedPack() {
          return this.querySelector('.quantity-pack__pack--selected');
        }

        onPackClick(event, customPack, updateInput) {
          const pack = event.currentTarget || customPack;
          let quantity = parseInt(pack.dataset.quantity);
          if (updateInput === false) quantity = parseInt(this.quantityInput.value);

          this.resetQuantityPack();
          pack.classList.add('quantity-pack__pack--selected');
          this.quantityInput.value = quantity;
          publish(PUB_SUB_EVENTS.quantityUpdate, {
            data: {
              quantity: quantity,
              source: 'quantity-pack',
            },
          });
        }

        resetQuantityPack() {
          this.packs.forEach((pack) => {
            pack.classList.remove('quantity-pack__pack--selected');
          });
        }

        onQuantityChanged(event) {
          if (event?.data.source !== 'quantity-input') return;

          const quantity = parseInt(event?.data.quantity) || parseInt(this.quantityInput?.value);
          this.packs.forEach((pack) => {
            if (parseInt(pack.dataset.quantity) == quantity) {
              this.onPackClick('', pack, false);
              return;
            }
          });

          this.onPackClick('', this.selectedPack, false);
        }
      }
    );
}